/**
 * Singleton Stytch Client
 * Creates a single instance of the Stytch client to be shared across the app
 */

import { StytchUIClient } from '@stytch/vanilla-js';
import { stytchConfig } from '../../config/stytch';

let stytchClient: StytchUIClient | null = null;

export function getStytchClient(): StytchUIClient | null {
  // Return existing client if already created
  if (stytchClient) {
    return stytchClient;
  }

  // Check if Stytch is configured
  if (!stytchConfig.publicToken || !stytchConfig.projectId) {
    return null;
  }

  // Create new client
  try {
    stytchClient = new StytchUIClient(stytchConfig.publicToken);
    return stytchClient;
  } catch (error) {
    console.error('Failed to create Stytch client:', error);
    return null;
  }
}